// File: src/vendors/react-export-excel/index.js
/*
    this source code is vendoring for "react-export-excel" package (it's using two vendored packages ["xlsx", "file-saver"] as dependencies for it)
    https://github.com/rdcalle/react-export-excel
*/
import React from 'react';

class ExcelFile extends React.Component {
    constructor(props) {
        super(props);
    }

    createSheetData(sheet) {
        const columns = sheet.props.children;
        const sheetData = [React.Children.map(columns, column => column.props.label)];
        
        sheet.props.data.forEach(row => {
            const rowData = [];
            React.Children.forEach(columns, column => {
                rowData.push(row[column.props.value] || '');
            });
            sheetData.push(rowData);
        });

        return sheetData;
    }

    async downloadExcel() {
        try {
            const XLSX = window.XLSX;
            const saveAs = window.saveAs;
            
            if (!XLSX || !saveAs) {
                throw new Error('Required dependencies not loaded');
            }

            const wb = XLSX.utils.book_new();
            const sheets = React.Children.toArray(this.props.children);

            sheets.forEach(sheet => {
                const sheetData = this.createSheetData(sheet);
                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                XLSX.utils.book_append_sheet(wb, ws, sheet.props.name);
            });

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

            const s2ab = s => {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            };

            saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), this.props.filename + '.xlsx');
        } catch (error) {
            console.error('Error in Excel export:', error);
        }
    }

    render() {
        const element = React.cloneElement(this.props.element || <span/>, {
            onClick: () => this.downloadExcel()
        });

        return element;
    }
}

// Critical: Define handleDownload on the prototype to match original package behavior
ExcelFile.prototype.handleDownload = function() {
    this.downloadExcel();
};

const ExcelSheet = ({ name, data, children }) => null;
const ExcelColumn = ({ label, value }) => null;

ExcelFile.ExcelSheet = ExcelSheet;
ExcelFile.ExcelColumn = ExcelColumn;

export default {
    ExcelFile,
    ExcelSheet,
    ExcelColumn
};